import type { ReactNode } from 'react';

export const symbol_language_gb_english: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M590-340h190v-110H590v110Zm0-170h190v-110H590v110ZM180-280q-24.75 0-42.37-17.63Q120-315.25 120-340v-280q0-24.75 17.63-42.38Q155.25-680 180-680h219q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H180v280h190v-110h-50q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h80q12.75 0 21.38 8.62Q430-492.75 430-480v140q0 24.75-17.62 42.37Q394.75-280 370-280H180Zm380 0q-12.75 0-21.37-8.63Q530-297.25 530-310v-340q0-12.75 8.63-21.38Q547.25-680 560-680h220q24.75 0 42.38 17.62Q840-644.75 840-620v90q0 20-15 35t-35 15q20 0 35 15t15 35v90q0 24.75-17.62 42.37Q804.75-280 780-280H560Z"
		/>
	</svg>
);
